<template>
  <order-list :is-order-status="40"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'Completed',
  components: {
    OrderList
  }
}
</script>
